export interface IPageTitleParams {
  type: PageTitleParamsType
  name: string
}

export enum PageTitleParamsType {
  PARAM,
  KEY,
}
